export const MORE = 'containerItems.more';
export const LESS = 'containerItems.less';
export const DURATION = 'containerItems.duration';
export const SEE_ALL = 'containerItems.seeAll';
export const SEE_MORE = 'containerItems.seeMore';
export const SEE_LESS = 'containerItems.seeLess';
